// The clear-ups (Adam, 5 Oct, stage 6, answer 5): the first time an owner or admin opens admin, it
// asks admin-tidy, once per page load and never while viewing as a member. The function itself runs
// at most once a London day (data-model 10.5), so later openings that day answer due false. Nothing
// is shown while it works or when it's done; if it fails, the owner alone gets 1 quiet line.
import { useEffect, useState } from 'react'

// Who asks: an owner or admin (support and hosts never do)
export const TIDIES = ['owner', 'admin']

// Refusals that aren't failures: a view-as session still open (in another tab, say), so that day's
// clear-up waits; or today's run already finished
const NOT_FAILED = ['viewing_as', 'no_run']

// Whether an answer, or a refusal, means the clear-up didn't finish: a refusal other than those, or a
// file Storage didn't remove (its rows are kept for a later day)
export function tidyFailed({ answer = null, error = null } = {}) {
  if (error) return !NOT_FAILED.includes(error.code)
  return Number(answer?.files?.failed || 0) > 0
}

// The 1 request a page load makes, and whether it failed; every later opening listens to the same one
let asking = null

export function useTidyOnOpen({ api, role, viewingAs }) {
  const [failed, setFailed] = useState(false)
  useEffect(() => {
    if (viewingAs || !TIDIES.includes(role)) return undefined
    if (!asking) {
      if (typeof api?.admin_tidy !== 'function') return undefined
      asking = api.admin_tidy({}).then(answer => tidyFailed({ answer }), error => tidyFailed({ error }))
    }
    let alive = true
    asking.then(didFail => { if (alive && didFail) setFailed(true) })
    return () => { alive = false }
  }, [api, role, viewingAs])
  // only the owner hears about it
  return role === 'owner' && failed
}
